import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { LOCATION_CONTROLER_URL } from "api/Service";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useSetDefaultLocation = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const handleNetworkError = useHandleNetworkError(
    "Error while setting default location"
  );

  return useMutation({
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}${LOCATION_CONTROLER_URL}/${id}/set-default`
      );

      return response.data;
    },
    onSuccess: async () => {
      toast.success("Default location updated");
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["locationsAll"] }),
        queryClient.invalidateQueries({ queryKey: ["locationsActive"] }),
      ]);
    },
    onError: handleNetworkError,
  });
};
